import PropTypes from 'prop-types';

const CargandoSpinner = ({ Cargando }) => {
  return (
    <section className="content">
        <div className="container-fluid">
                {Cargando && <div className="centered">
                <div><progress value={null} /></div>
                </div>}
        </div>
    </section>
    
  );
};

CargandoSpinner.propTypes = {
  Cargando: PropTypes.bool.isRequired,
};

export default CargandoSpinner
